<div class="metabase-container" *ngIf="token">
    <metabase-dashboard
        [attr.token]="token"
        [attr.with-title]="withTitle ? 'true' : 'false'"
        [attr.with-downloads]="withDownloads ? 'true' : 'false'"
        [attr.initial-parameters]="formattedInitialParameters"
    >
    </metabase-dashboard>
</div>
